import { API_PENDING_ERP_SYNC } from 'utils/constants'
import Api from './axiosInstance'
import { buildQueryParams } from 'utils/helpers/buildQueryParams'

type FetchOpenOrdersParams = {
  limit: number
  page: number
  search?: string
}

export const fetchPendingErpSyncOrders = ({
  limit,
  page,
  search,
}: FetchOpenOrdersParams) => {
  const params = buildQueryParams({
    limit,
    page,
    search,
  })

  return Api.get({
    url: API_PENDING_ERP_SYNC.ORDER,
    params: params,
  })
}

export const fetchPendingErpSyncRma = ({
  limit,
  page,
  search,
}: FetchOpenOrdersParams) => {
  const params = buildQueryParams({
    limit,
    page,
    search,
  })

  return Api.get({
    url: API_PENDING_ERP_SYNC.RMA,
    params: params,
  })
}

export const fetchPendingErpSyncRecon = ({
  limit,
  page,
  search,
}: FetchOpenOrdersParams) => {
  const params = buildQueryParams({
    limit,
    page,
    search,
  })

  return Api.get({
    url: API_PENDING_ERP_SYNC.RECON,
    params: params,
  })
}

export const resyncErpAttemptedOrder = (orderNo: string) => {
  return Api.post({ url: `${API_PENDING_ERP_SYNC.ORDER}/${orderNo}/resync` })
}

export const resyncErpAttemptedRma = (rmaNo: string) => {
  return Api.post({ url: `${API_PENDING_ERP_SYNC.RMA}/${rmaNo}/resync` })
}

export const resyncErpAttemptedRecon = (
  orderNo: string,
  type: 'RMA' | 'ORDER',
) => {
  return Api.post({
    url: `${API_PENDING_ERP_SYNC.RECON}/${orderNo}/resync`,
    data: { type },
  })
}
